import React, { useRef } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { oneDark } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { oneLight } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { MermaidDiagram } from './MermaidDiagram';
import { TranslationKey } from '../i18n/translations';
interface PreviewProps {
  markdown: string;
  isDark: boolean;
  t: (key: TranslationKey) => string;
}
export function Preview({
  markdown,
  isDark,
  t
}: PreviewProps) {
  const previewRef = useRef<HTMLDivElement>(null);
  return <div className={`flex-1 rounded-2xl shadow-sm flex flex-col overflow-hidden ${isDark ? 'bg-[#242830]' : 'bg-white'}`} data-id="element-61">
      <div className={`px-8 py-4 border-b ${isDark ? 'bg-[#2d3340] border-[#3a3f4a]' : 'bg-[#fafafa] border-[#e8ecf0]'}`} data-id="element-62">
        <h2 className={`text-sm font-light tracking-wide ${isDark ? 'text-[#7b92a8]' : 'text-[#5b7c8d]'}`} data-id="element-63">
          {t('preview.title')}
        </h2>
      </div>
      <div className="flex-1 overflow-y-auto p-8" ref={previewRef} data-id="element-64">
        <div className={`prose prose-slate max-w-none ${isDark ? 'prose-invert' : ''}`} data-id="element-65">
          <ReactMarkdown remarkPlugins={[remarkGfm]} components={{
          code({
            node,
            inline,
            className,
            children,
            ...props
          }) {
            const match = /language-(\w+)/.exec(className || '');
            const language = match ? match[1] : '';
            if (!inline && language === 'mermaid') {
              const code = String(children).replace(/\n$/, '');
              return <MermaidDiagram code={code} isDark={isDark} t={t} data-id="element-67" />;
            }
            return !inline && match ? <SyntaxHighlighter style={isDark ? oneDark : oneLight} language={language} PreTag="div" {...props} data-id="element-68">
                    {String(children).replace(/\n$/, '')}
                  </SyntaxHighlighter> : <code className={className} {...props} data-id="element-69">
                    {children}
                  </code>;
          }
        }} data-id="element-66">
            {markdown}
          </ReactMarkdown>
        </div>
      </div>
    </div>;
}